import { NgModule } from '@angular/core';

import { FloorPipe } from './floor.pipe';
import { CeilPipe } from './ceil.pipe';
import { SimNaoPipe } from './sim-nao.pipe';
import { DateFormatPipe } from './date-pt.pipe';


@NgModule({
    declarations: [ FloorPipe, CeilPipe, SimNaoPipe,DateFormatPipe ],
    exports: [ FloorPipe,CeilPipe, SimNaoPipe,DateFormatPipe],
    providers:[SimNaoPipe]
})
export class PipesModule { 
    
}
